import React, { useEffect, useRef, useState } from 'react';
import './style.scoped.scss';
import RegCityLogo from '../../components/Account/RegCityLogo';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../assets/constants/strings';
import { FaArrowLeft, FaCheck } from 'react-icons/fa';
import ContactUsModal from './ContactUsModal';
import { PADDLE_PLANS } from '../../assets/constants/PaddleStrings';
import {
  GetPaddlePrices,
  GetPaddleProducts,
} from '../../store/Paddle/paddleActions';
import { connect } from 'react-redux';
import { FaExternalLinkAlt } from 'react-icons/fa';

const mapStateToProps = (state) => ({
  user: state.user.user,
  paddleProducts: state.paddle.products,
  paddlePrices: state.paddle.prices,
});

const mapDispatchToProps = {
  GetPaddleProducts,
  GetPaddlePrices,
};

const Plans = ({
  selected,
  handleSelected,
  isUpdate,
  user,
  paddleProducts,
  paddlePrices,
  GetPaddleProducts,
  GetPaddlePrices,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 911);
  const [plans, setPlans] = useState([]);

  // using refs to ensure the load logic works
  const screenRef = useRef(isSmallScreen);
  screenRef.current = isSmallScreen;

  useEffect(() => {
    // listen for changes in window width for hide/show logic
    window.addEventListener('resize', checkScreenSize);

    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  const checkScreenSize = () => {
    screenRef.current = window.innerWidth < 911;
    setIsSmallScreen(screenRef.current);
  };

  useEffect(() => {
    if (!paddleProducts) GetPaddleProducts();
    if (!paddlePrices) GetPaddlePrices();
  }, []);

  useEffect(() => {
    if (paddleProducts?.length > 0 && paddlePrices?.length > 0 && user) {
      const userPlans = user.userPlans;

      const newPlans = [];

      paddlePrices.forEach((paddleItem) => {
        userPlans.forEach((userItem) => {
          if (userItem.name === paddleItem.name) {
            const paddlePlan = PADDLE_PLANS.find(
              (plan) => plan.title === paddleItem.name
            );
            if (paddlePlan) {
              newPlans.push({
                id: userItem.id,
                title: userItem.name,
                price: userItem.price,
                aiLimit: userItem.aiLimit,
                pageViewLimit: userItem.pageViewLimit,
                shareLimit: userItem.shareLimit,
                isMostSelected: userItem.name === 'Pro',
                paddlePriceId: paddleItem.id,
                features: paddlePlan.features,
                extras: paddlePlan.extras,
              });
            }
          }
        });
      });

      const enterprisePlan = userPlans.filter(
        (plan) => plan.name === 'Enterprise'
      )[0];

      newPlans.push({
        id: enterprisePlan.id,
        title: enterprisePlan.name,
        price: 'Custom',
        aiLimit: enterprisePlan.aiLimit,
        pageViewLimit: enterprisePlan.pageViewLimit,
        shareLimit: enterprisePlan.shareLimit,
        isMostSelected: false,
        paddlePriceId: '',
        features: PADDLE_PLANS.filter((item) => item.title === 'Enterprise')[0]
          .features,
        extras: PADDLE_PLANS.filter((item) => item.title === 'Enterprise')[0]
          .extras,
      });

      setPlans(newPlans.sort((a, b) => (Number(a.id) > Number(b.id) ? 1 : -1)));
      // console.log('newPlans', newPlans);
    }
  }, [paddleProducts, paddlePrices, user]);

  const handleClick = (plan, isEnterprise = false) => {
    if (isEnterprise) {
      setShowModal(true);
      handleSelected(plan);
    } else handleSelected(plan);
  };

  const openNewTab = () => {
    window.open('https://regulationcity.com/contact-us/', '_blank');
  };

  return (
    <div className='plans'>
      <div className='plans__logo'>
        {isUpdate && (
          <Link to={ROUTES.MEMBERSHIP_INFO} className='back-button backButton'>
            <FaArrowLeft />
            <p>Back</p>
          </Link>
        )}
        <RegCityLogo isPlans />
      </div>
      <h2>Select your RegulationCity Plan</h2>

      <div
        className={`plans__cards ${isSmallScreen ? '' : 'marginTop'}
      }`}
      >
        {plans.map((plan, index) => {
          return (
            <div className='d-flex flex-column' key={plan.id}>
              {plan.isMostSelected ? (
                <div
                  className={`mostSelected
              ${selected.title === 'Pro' ? 'active' : ''}
              ${isSmallScreen ? 'marginTop' : ''}`}
                >
                  <b>Most Selected</b>
                </div>
              ) : (
                <div className='cardEmpty'></div>
              )}

              <div
                className={`plans__card col-3 ${
                  selected.title === plan.title ? 'active' : ''
                } ${plan.isMostSelected ? '' : 'marginTop'}
                ${
                  isUpdate && plan.title === user.userPlan.subscriptionName
                    ? 'planDisabled'
                    : ''
                }
                `}
                onClick={() =>
                  plan.title === 'Enterprise'
                    ? openNewTab()
                    : isUpdate && plan.title === user.userPlan.subscriptionName
                    ? null
                    : handleClick(plan, false)
                }
              >
                <div className='plans__card__title'>
                  <h4 className='m-0 p-0'>{plan.title}</h4>
                  <b className='m-0 p-0'>
                    {plan.title === 'Enterprise'
                      ? plan.price
                      : `$${plan.price}/month`}
                  </b>
                </div>
                <Button
                  className={`${
                    selected.title === plan.title ? 'buttonActive' : ''
                  }
                    ${
                      isUpdate && plan.title === user.userPlan.subscriptionName
                        ? 'planDisabled'
                        : ''
                    }
                    `}
                  variant={
                    selected.title === plan.title ? 'primary' : 'success'
                  }
                  disabled={
                    isUpdate && plan.title === user.userPlan.subscriptionName
                      ? 'planDisabled'
                      : ''
                  }
                >
                  {selected.title === plan.title ? (
                    <span className='mr-2'>
                      <FaCheck />
                    </span>
                  ) : null}
                  {plan.title === 'Enterprise' ? (
                    <span>
                      Contact Us
                      <span className='ml-2'>
                        <FaExternalLinkAlt />
                      </span>
                    </span>
                  ) : selected.title === plan.title ? (
                    'Selected'
                  ) : (
                    'Select Plan'
                  )}
                </Button>

                <hr />

                <div className='plans__card__features'>
                  {plan.features.map((item, i) => {
                    return (
                      <div
                        key={`${i}-features`}
                        className='plans__card__features__items'
                      >
                        <span>
                          <b>{item.title}</b>
                        </span>
                        <span>
                          <b>{item.value}</b>
                        </span>
                      </div>
                    );
                  })}
                </div>

                <hr className='my-4' />

                <div className='plans__card__extras'>
                  {plan.extras &&
                    plan.extras.map((item, i) => {
                      return (
                        <div
                          key={`${i}-extras`}
                          className='plans__card__extras__items'
                        >
                          <FaCheck />
                          <b className='ml-2'>{item}</b>
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <ContactUsModal
        show={showModal}
        handleClose={() => setShowModal(false)}
      />
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Plans);
